<template>
    <el-dialog
        :title="getText('audit_report_override_modal_title')"
        :visible.sync="showModal"
        width="80%"
        :show-close="false"
        class="modale-value-override"
        append-to-body
    >
        <el-tabs tab-position="left">

            <el-tab-pane
                v-for="motor in motors"
                :key="motor"
                :label="motor"
            >
                <div
                    v-for="(solution, solutionIndex) in overriddenAuditData[motor].solutions_table"
                    :key="solutionIndex"
                    style="padding: 10px 20px;"
                >
                    <el-divider v-if="solutionIndex > 0"></el-divider>
                    <p class="solution-name">{{solution.name}}</p>
                    <el-row
                        v-for="(overridableKey, overridableKeyIndex) in overridableKeys(solution)"
                        :key="`${solutionIndex}${overridableKeyIndex}`"
                        :gutter="20"
                        type="flex"
                        align="middle"
                        class="value-row"
                    >
                        <el-col :span="8">
                            <p>{{overridableKeyVerbose(overridableKey)}}</p>
                        </el-col>
                        <el-col :span="8">
                            <overridden-audit-data-input
                                :auditDataValue="solution[overridableKey]"
                                :motor="motor"
                                :solutionIndex="solutionIndex"
                                :overridableKey="overridableKey"
                                @saveNewValue="saveNewValue"
                            ></overridden-audit-data-input>
                        </el-col>
                        <el-col :span="8">
                            <p v-if="getOverriddenSolution(solution, motor)[overridableKey] !== parseFloat(solution[overridableKey])">{{getText('audit_report_override_modal_initial_value_label')}} {{getOverriddenSolution(solution, motor)[overridableKey]}}</p>
                        </el-col>
                    </el-row>
                </div>
            </el-tab-pane>
        </el-tabs>

        <span slot="footer">
            <el-button class="whiteButton" @click="closeModal">{{getText('cancel_button')}}</el-button>
            <el-button class="greenButton"  @click="emitValidation">{{getText('audit_report_override_modal_validate_button')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import overriddenAuditDataInput from './overriddenAuditDataInput.vue'
import {mapGetters} from 'vuex';
export default {

    components: {
        overriddenAuditDataInput
    },

    props: {
        overriddenAuditData: {
            type: Object,
            required: true
        },
        defaultAuditData: {
            type: Object,
            required: true
        }
    },

    data: function(){
        return {
            showModal: false,
            keyVerbose: {
                'fr': {
                    'gains_k_an': 'Gain par an (k€)',
                    'gains_mwh': 'Gain d\'énergie (MWh)',
                    'invest': 'Investissement brut (€)',
                    'invest_cee': 'Investissement avec CEE (€)',
                    'roi': 'TRI',
                    'roi_cee': 'TRI avec CEE',
                    'vol_cee': 'Montant des CEE (€)'
                },
                'en': {
                    'gains_k_an': 'Annual gain (k€)',
                    'gains_mwh': 'Annual energy gain (MWh)',
                    'invest': 'Investments (€)',
                    'invest_cee': 'Investments with CEE (€)',
                    'roi': 'ROI',
                    'roi_cee': 'ROI with CEE',
                    'vol_cee': 'CEE amount (€)'
                }
            }
        };
    },

    computed: {
        ...mapGetters([
            'getText',
            'getLangage'
        ]),
        motors() {
            return Object.keys(this.overriddenAuditData);
        },
    },

    methods: {
        getOverriddenSolution(solution, motor) {
            let overriddenSolution = this.defaultAuditData[motor].solutions_table.find(sol => sol.name === solution.name)
            return overriddenSolution ? overriddenSolution : solution
        },
        overridableKeyVerbose(key) {
            return this.keyVerbose[this.getLangage][key];
        },
        overridableKeys(solution) {
            let availableKeys =['gains_k_an', 'gains_mwh', 'invest', 'invest_cee', 'roi', 'roi_cee', 'vol_cee'];

            return availableKeys.filter(key => Object.keys(solution).includes(key));
        },
        emitValidation() {
            this.closeModal();
            this.$emit('sendOverriddenValues');
        },
        open() {
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
        },
        saveNewValue(payload) {
            this.$emit('saveNewValue', payload);
        }
    },
};
</script>

<style lang="scss">
.modale-value-override {
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    .solution-name {
        font-size: 18px;
    }
    .value-row {
        p {
            margin: 0;
        }
        +.value-row {
            margin-top: 10px;
        }
    }
    .el-tabs__item.is-active, .el-tabs__item:hover {
        color: #C4D600;
    }
    .el-tabs__active-bar {
        background-color: #C4D600;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/report/modaleValueOverride.vue